import styled from "@emotion/styled";
import { StyledTh } from "../../../../styled";
import { type BurgerProps, createPolymorphicComponent } from "@mantine/core";

export const TriangleContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  box-sizing: border-box;
`;

export const DiagonalLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`;

export const LeftItemContainer = styled.div`
  position: absolute;
  z-index: 2;
  font-weight: bold;

  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 60%;
  word-break: break-word;
  font-size: 0.9em;
  padding: 4px;
`;

export const RightItemContainer = styled.div`
  position: absolute;
  z-index: 2;
  font-weight: bold;

  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 60%;
  word-break: break-word;
  font-size: 0.9em;
  padding: 4px;
`;
